import type { ValidationTranslation } from './validation.translation.pl.ts';

export const validationTranslation: ValidationTranslation = {
  general: {
    required: 'This field is required',
    maxLength: 'The maximum length is {{max}} characters',
  },
  phoneNumber: {
    format: 'The phone number must have 9 to 15 digits',
  },
  url: {
    format: 'The link should start with https://',
  },
};
